<template>
	<div>
		<el-drawer
			:before-close="
				done => {
					return done(true)
				}
			"
			:modal="false"
			:close-on-press-escape="true"
			:append-to-body="true"
			:wrapperClosable="false"
			:visible.sync="visible"
			size="100%"
		>
			<div slot="title">
				<h3>Contenuto colonna</h3>
			</div>
			<div style="height: 90%; width: 100%">
				<el-tooltip class="item" effect="dark" :content="$t('paste')" placement="top-start">
					<el-button class="_btn" v-if="cut && isEditable" @click="pasteAt(list, -1)" circle>
						<md-icon>content_paste</md-icon>
					</el-button>
				</el-tooltip>
				<draggable
					:key="'super_cool_draggable' + show"
					:list="list"
					class="list-group"
					:options="dragOptionsInside2"
					v-bind:style="styleObject"
					:empty-insert-threshhold="500"
					handle=".handle"
					:scroll-sensitivity="200"
					:force-fallback="true"
				>
					<el-card
						class="box-card"
						v-for="(element, idx) in list"
						:key="element.id + isEditable"
						:style="{ border: element.ref_id !== undefined ? '4px solid #409eff' : 'none' }"
					>
						<div style="width: 100%; height: auto; min-height: 60px">
							<md-icon class="handle" style="float: left">open_with</md-icon>
							<el-badge
								v-if="element.ref_id !== undefined"
								:value="$t('saved-block')"
								class="item"
								type="primary"
							>
								<div style="max-width: 300px; overflow: hidden">{{ element.name }}</div>
							</el-badge>
							<div style="display: inline" v-else>{{ element.name }}</div>
							<el-tooltip v-if='element.wiki' style='border:none; width: 25px; left: 90px; position: relative' class="item" effect="dark" :content="element.wiki" placement="top">
								<md-icon>help_outline</md-icon>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="$t('delete')" placement="top-start">
								<el-button class="_btn" v-if="isEditable" @click="removeAt(idx)" circle>
									<md-icon>delete</md-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="$t('clone')" placement="top-start">
								<el-button class="_btn" v-if="isEditable" @click="cloneAt(list, idx)" circle>
									<md-icon>content_copy</md-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="$t('cut')" placement="top-start">
								<el-button class="_btn" v-if="!cut && isEditable" @click="cutAt(list, idx)" circle>
									<md-icon>content_cut</md-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="$t('paste')" placement="top-start">
								<el-button class="_btn" v-if="cut && isEditable" @click="pasteAt(list, idx)" circle>
									<md-icon>content_paste</md-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip
								class="item"
								effect="dark"
								:content="$t('save-as-new-block')"
								placement="top-start"
							>
								<el-button
									class="_btn"
									v-if="isEditable && element.ref_id === undefined"
									@click="saveEl(element)"
									circle
								>
									<md-icon>save</md-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="$t('edit-style')" placement="top-start">
								<el-button
									class="_btn"
									v-if="isEditable && element.ref_id === undefined"
									@click="editEl(element)"
									circle
								>
									<md-icon>edit</md-icon>
								</el-button>
							</el-tooltip>
							<el-tooltip
								class="item"
								effect="dark"
								:content="$t('edit-as-single-blocks')"
								placement="top-start"
							>
								<el-button
									class="_btn"
									v-if="element.ref_id !== undefined"
									@click="editElAsBlock(element)"
									circle
								>
									<md-icon>post_add</md-icon>
								</el-button>
							</el-tooltip>
						</div>

						<reflect-component
							:isEditable="isEditable && element.ref_id === undefined"
							:key="element.id + 'subelements'"
							:element="element"
						></reflect-component>
					</el-card>
				</draggable>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import draggable from "vuedraggable"
import ReflectComponent from "@/modules/builder/Reflect/reflect-component"
import { clone, cloneAt } from "../utils/utils"
import { mapActions, mapGetters } from "vuex"

export default {
	name: "lateral-editor",
	props: ["show", "elemento", "isEditable"],
	components: {
		draggable,
		ReflectComponent,
		clone,
		cloneAt
	},
	watch: {
		show(e) {}
	},
	computed: {
		...mapGetters({
			cut: "builder/cut"
		}),
		list: {
			get() {
				return this.elemento
			},
			set(val) {
				val
				this.$emit("updateval", val)
			}
		},
		visible: {
			get() {
				return this.show
			},
			set(val) {
				this.$emit("changeShow", val)
			}
		},
		dragOptionsInside2() {
			return {
				group: {
					name: "items",
					pull: this.isEditable,
					put: this.isEditable,
					move: this.isEditable
				},
				sort: this.isEditable,
				disabled: !this.isEditable,
				ghostClass: "ghost",
				chosenClass: "dragCustomClass",
				animation: 200
			}
		}
	},
	data() {
		return {
			styleObject: {
				"min-height": "100px",
				height: "90%",
				width: "100%",
				"min-width": "60px",
				border: "1px dotted black",
				// 'width': (90 / this.children) + '%',
				display: "inline-block"
			},
			styleObjectParent: {
				"min-height": "100px",
				height: "100%",
				"min-width": "80%",
				border: "none"
			},
			opened: undefined
		}
	},
	methods: {
		...mapActions({
			setCut: "builder/setCut",
			resetCut: "builder/resetCut"
		}),
		async cutAt(list, id) {
			await this.setCut(list[id])
			list.splice(id, 1)
			this.$el.focus()
		},
		async pasteAt(list, id) {
			list.splice(id + 1, 0, this.cut)
			await this.resetCut()
			this.$el.focus()
		},
		editElAsBlock(el) {
			/**
			 * DOC
			 * trigger l'edit css dell'elemento come blocco perchè lui è bloccato ma vabbè ok
			 *
			 * */
			this.$confirm(this.$t("warning-edit-shared-block"), "Attenzione", {
				confirmButtonText: "OK",
				cancelButtonText: "Cancel",
				type: "warning"
			})
				.then(() => {
					el.ref_id = undefined
				})
				.catch(() => {})
		},
		...mapActions({
			addElement: "builder/addElement",
			editInsert: "builder/editInsert",
			editEdit: "builder/editEdit",
			showModalInsert: "builder/showModalInsert",
			hideModalInsert: "builder/hideModalInsert",
			hideModalEdit: "builder/hideModalEdit",
			showModalEdit: "builder/showModalEdit"
		}),
		editEl(el) {
			this.editEdit(el)
			this.showModalEdit()
		},
		saveEl(el) {
			var toinsertel = clone(el)
			toinsertel.name += "(salvato)"
			toinsertel.id = Math.random().toString(16).slice(2)
			this.editInsert(toinsertel)
			this.showModalInsert()
		},
		removeAt(idx) {
			this.list.splice(idx, 1)
		},
		updateIfNeeded() {
			if (this.componenti.length <= 0) {
				/**
				 * DOC
				 *
				 * Spiegazione funzione carina
				 *
				 * quando hai l'array dei figli vuoti c'è un problema di render e si rompe tutto.
				 * Perchè l'array è [] così
				 * per funzionare dovrebbe essere  [[],[]] per esempio nel caso di due colonne
				 * per evitare di scriverlo nella dichiarazione, questa funzione si occupa di istanziarlo al create dell'elemento
				 * quindi pusha x array vuoti sull'array parent
				 *
				 * se non è chiaro, all'occurrenza farò un disegnino
				 * */
				this.$emit(
					"updateComp",
					Array(this.children)
						.fill("")
						.map(() => Array())
				)
				// this.componenti=  Array( this.children ).fill( "" ).map( () => Array() )
			}
		},
		cloneAt(a, b) {
			cloneAt(a, b)
		},
		clone(a) {
			return clone(a)
		}
	}
}
</script>
<style scoped>
.el-drawer__wrapper {
	z-index: 11 !important;
	width: 40% !important;
	position: fixed !important;
	left: auto !important;
}
</style>
